import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TokenService } from './token.service';

@Injectable({
    providedIn: 'root'
})
export class EmbarqueService {
    apiUrl = environment.API_URL + 'internal/';

    constructor(
        private httpClient: HttpClient,
        private tokenService: TokenService
    ) { }

    getCustomerHeader() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.tokenService.getComponentCodeToken(),
            'Accept-Language': 'pt-BR'
        });
    }

    public getBatchItemByCode(branchCode: number, batchCode: number): Observable<any> {
        const url = this.apiUrl + 'product/v2/batch-item/search';

        const body = {
            branchCode,
            batchCode,
            sequence: 0,
            batchItemBarCode: '',
            locationCode: '',
            page: 1,
            pageSize: 100
        };

        return this.httpClient.post<any>(url, body, { headers: this.getCustomerHeader() });
    }

    public getBatchItemByBarCode(branchCode: number, batchItemBarCode: string): Observable<any> {
        const url = this.apiUrl + 'product/v2/batch-item/search';

        const body = {
            branchCode,
            locationCode: '',
            batchItemBarCode,
            page: 1,
            pageSize: 100
        };

        return this.httpClient.post<any>(url, body, { headers: this.getCustomerHeader() });
    }

    public getInvoiceItems(branchCode: number, invoiceSequence: number, invoiceDate: string, page: number = 1, pageSize: number = 100): Observable<any> {
            let params = new HttpParams()
                .set('BranchCode', branchCode)
                .set('InvoiceSequence', invoiceSequence)
                .set('InvoiceDate', invoiceDate)
                .set('Page', page)
                .set('PageSize', pageSize);
    
            return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/checking-invoice-itens', {
                headers: this.getCustomerHeader(),
                params
            });
    }

    public postBoardingConferenceHeader(
        countBranchCode: number,
        countCode: number,
        invoiceBranchCode: number,
        invoiceSequence: number,
        statusType: any,
        orderCode: number,
        orderBranchCode: number,
        invoiceDate?: string,
        userCode?: string
    ): Observable<any> {
        const data = {
            countBranchCode,
            countCode,
            invoiceBranchCode,
            invoiceSequence,
            invoiceDate,
            statusType,
            separatorCode: 1,
            orderCode,
            orderBranchCode,
            conferentUserCode: userCode ? Number(userCode) : undefined,
        };

        return this.httpClient.post<any>(
            this.apiUrl + 'product-count/v2/boarding-conference-header',
            data,
            { headers: this.getCustomerHeader() }
        );
    }

    public getBoardingConference(
        branchCode: number,
        invoiceSequence: number,
        startIssueDate: string,
        endIssueDate: string,
        status?: number,
        page: number = 1,
        pageSize: number = 1000
    ): Observable<any> {
        let params = new HttpParams()
            .set('BranchCode', branchCode)
            .set('InvoiceSequence', invoiceSequence)
            .set('StartIssueDate', startIssueDate)
            .set('EndIssueDate', endIssueDate)
            .set('Page', page)
            .set('PageSize', pageSize);

        if (status !== undefined) {
            params = params.set('Status', status);
        }

        return this.httpClient.get<any>(
            this.apiUrl + 'product-count/v2/boarding-conference',
            {
                params,
                headers: this.getCustomerHeader()
            }
        );
    }

    public getCheckingInvoicesAccessKey(accessKey: string): Observable<any> {
        let params = new HttpParams()
            .set('Page', 1)
            .set('PageSize', 1000)
            .set('AccessKey', accessKey);

        if (accessKey) {
            params = params.set('AccessKey', accessKey);
        }

        return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/checking-invoices', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public getProduct(BarCode: any, BranchCode: number): Observable<any> {
        return this.httpClient.get<any>(this.apiUrl + 'product/v2/products/' + BarCode + '/' + BranchCode, { headers: this.getCustomerHeader() });
    }

    
    public postConferenceCountItem(branchCode: number, code: number, productCode: number, barCode: string, quantity: number = 1): Observable<any> {
            const url = this.apiUrl + 'product-count/v2/counts-item';
            
            const body = {
                branchCode,
                code,
                productCode,
                barCode,
                quantity
            };
    
            return this.httpClient.post<any>(url, body, {
                headers: this.getCustomerHeader()
            }).pipe(
                tap({
                    next: (response) => {
                    },
                    error: (error) => {
                    }
                })
            );
        }

    public postCount(branchCode: number, description: string, component: string): Observable<any> {
        const data = {
            branchCode: branchCode,
            description: description,
            component: component
        };

        return this.httpClient.post<any>(
            this.apiUrl + 'product-count/v2/counts',
            data,
            { headers: this.getCustomerHeader() }
        );
    }

    public getCheckingInvoices(branchCode: number, invoiceCode?: number, serialCode?: number, page: number = 1, pageSize: number = 100, invoiceDate?: string): Observable<any> {
        let params = new HttpParams()
            .set('BranchCode', branchCode)
            .set('Page', page)
            .set('PageSize', pageSize);

        if (invoiceCode) {
            params = params.set('InvoiceCode', invoiceCode);
        }

        if (serialCode) {
            params = params.set('SerialCode', serialCode);
        }

        if (invoiceDate) {
            params = params.set('StartDate', invoiceDate);
            params = params.set('EndDate', invoiceDate);
        }

        return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/checking-invoices', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public getBoardingConferenceItems(
        branchCode: number,
        invoiceSequence: number,
        issueDate: string
    ): Observable<any> {
        let params = new HttpParams()
            .set('BranchCode', branchCode)
            .set('InvoiceSequence', invoiceSequence)
            .set('IssueDate', issueDate)
            .set('Page', 1)
            .set('PageSize', 1000);

        return this.httpClient.get<any>(
            this.apiUrl + 'product-count/v2/boarding-conference-items',
            {
                params: params,
                headers: this.getCustomerHeader()
            }
        );
    }

    public postBoardingConferenceStatus(
        countBranchCode: number,
        countCode: number,
        invoiceBranchCode: number,
        invoiceSequence: number,
        invoiceDate: string,
        statusType: string
    ): Observable<any> {
        const data = {
            countBranchCode,
            countCode,
            invoiceBranchCode,
            invoiceSequence,
            invoiceDate,
            statusType
        };

        return this.httpClient.post<any>(
            this.apiUrl + 'product-count/v2/boarding-conference-status',
            data,
            { headers: this.getCustomerHeader() }
        );
    }
}